<template>

    <FloatingPanel>

        <div class="common-canvas-blocks-common-quote-BlockPanel">

            <div class="tw-px-4 tw-py-3 text">

                <div class="tw-mb-1 tw-text-gray-600 label">Anchor (link within page)</div>

                <input
                        type="text"
                        class="form-control"
                        @input="$set(options, 'anchor', $event.target.value)"
                        placeholder="categorie"
                        :value="options.anchor" />

            </div>

            <div class="tw-px-4 tw-py-3 text">

                <div class="tw-mb-1 tw-text-gray-600 label">Spacing (top and bottom)</div>

                <select
                        class="form-control"
                        @input="$set(options, 'marge', $event.target.value)"
                        v-model="options.marge">
                    <option v-for="option in marge" :value="option.value">{{ option.text }}</option>
                </select>

            </div>

            <div class="tw-px-4 tw-py-3 colors">

                <div class="tw-mb-1 tw-text-gray-600 label">Background color</div>

                <button
                        v-for="color in colors"
                        :style="{ background: color }"
                        class="tw-w-8 tw-h-8 tw-border tw-border-gray-400 tw-inline-block tw-m-1 tw-shadow-sm tw-cursor-pointer color"
                        :class="{ selected: color == currentColor }"
                        @click="setColor(color)" />

            </div>

        </div>

    </FloatingPanel>

</template>

<script>

    import AbstractPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/AbstractPanel";
    import FloatingPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/panels/FloatingPanel";

    export default {

        extends: AbstractPanel,

        components: {
            FloatingPanel,
        },

        data() {
            return {
                colors: [
                    '#ffffff',
                    '#00000008',
                ],
                marge: [
                    {
                        'text': 'Geen',
                        'value': '',
                    },
                    {
                        'text': 'Klein',
                        'value': 'tw-py-2 md:tw-py-4',
                    },
                    {
                        'text': 'Middel',
                        'value': 'tw-py-4 md:tw-py-8',
                    },
                    {
                        'text': 'Groot',
                        'value': 'tw-py-6 md:tw-py-14',
                    },
                ]
            };
        },

        methods: {

            setColor(color)
            {
                // Set
                this.$set(this.options, 'color', color);
            },

        },

        computed: {

            currentColor()
            {
                return this.options.color;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .common-canvas-blocks-common-quote-BlockPanel {

    }

</style>